// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import bootstrap from 'bootstrap'
import jquery from 'jquery'
import {Pagination, PaginationEvent} from 'vue-pagination-2'
import SocialSharing from 'vue-social-sharing'
// import VTooltip from 'v-tooltip'
import VueAnalytics from 'vue-analytics'
import VueSweetAlert from 'vue-sweetalert'
import Meta from 'vue-meta'
// import FullCalendar from 'vue-full-calendar'
// import 'fullcalendar/dist/fullcalendar.min.css'
import Multiselect from 'vue-multiselect'

// register globally
// Vue.use(FullCalendar)
// import vueHeadful from 'vue-simple-headful'
// const prio = require('prerender-node').set('prerenderToken', 'RUaZ4IiogChhTF802Xk1')
Vue.config.productionTip = false
/* social share plugin */
Vue.use(SocialSharing)
Vue.use(VueSweetAlert)
Vue.use(Meta)
Vue.component('multiselect', Multiselect)
// Vue.use(vueHeadful)

/* tooltip plugin */
// Vue.use(VTooltip)
// Vue.use(require('prerender-node').set('prerenderToken', 'Du2s8J9rXbxwE0wa5yKN')) commented

/* eslint-disable no-new */
const app = new Vue({
    jquery,
    bootstrap,
    router,
    store,
    Pagination,
    PaginationEvent,
    template: '<App/>',
    components: { App }
})

VueAnalytics.onScriptLoaded().then(() => {
    // console.info('VueAnalytics loaded')
    app.$mount('#app')
})

Vue.use(VueAnalytics, {
    onReady () {
       //  console.info('VueAnalytics ready')
    },
    id: 'UA-104790802-2',
    router,
    autoTracking: {
        pageviewTemplate (route) {
            // console.info('VueAnalytics routes', route)
            return {
                page: route.path,
                title: document.title,
                location: window.location.href
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js